<template>
	<div class="table-net-income-details">
		<b-table-simple bordered responsive>
			<b-thead>
				<b-tr>
					<b-th class="text-white">Customer Name: {{ customer.name }}</b-th>
					<b-th class="text-white">MYR</b-th>
					<b-th class="text-white" v-if="isForeigIncome">{{ currency }}</b-th>
				</b-tr>
			</b-thead>
			<b-tbody>
				<b-tr
					v-if="customer.incomes.main.income_type_id === 2 && customer.incomes.main.business_income_type === 'Borang B'">
					<b-th scope="row">Borang B</b-th>
					<b-td>{{ customer.incomes.main.company_bank_statement | moneyFormatter }}</b-td>
					<b-td>{{ _gHlp.currencyFromRM(customer.incomes.main.company_bank_statement) }}</b-td>
				</b-tr>
				<b-tr
					v-else-if="customer.incomes.main.income_type_id === 2 && customer.incomes.main.business_income_type === 'Company Bank Statement'">
					<b-th scope="row">Company Bank Statement</b-th>
					<b-td>{{ customer.incomes.main.company_bank_statement | moneyFormatter }}</b-td>
				</b-tr>
				<b-tr v-else>
					<b-th scope="row">Salary</b-th>
					<b-td>{{ customer.incomes.main.monthly_salary | moneyFormatter }}</b-td>
					<b-td v-if="isForeigIncome">{{ _gHlp.currencyFromRM(customer.incomes.main.monthly_salary,
						this.main_form.foreign_currency) | moneyFormatter }}</b-td>
				</b-tr>
				<b-tr>
					<b-th scope="row">Fixed Allowance</b-th>
					<b-td>{{ customer.incomes.main.fixed_allowance | moneyFormatter }}</b-td>
					<b-td v-if="isForeigIncome">{{ _gHlp.currencyFromRM(customer.incomes.main.fixed_allowance,
						this.main_form.foreign_currency) | moneyFormatter }}</b-td>
				</b-tr>
				<b-tr>
					<b-th scope="row">Average Variable Income</b-th>
					<b-td>{{ customer.incomes.main.av_var_inc | moneyFormatter }}</b-td>
					<b-td v-if="isForeigIncome">{{ _gHlp.currencyFromRM(customer.incomes.main.av_var_inc,
						this.main_form.foreign_currency) | moneyFormatter }}</b-td>
				</b-tr>
				<b-tr>
					<b-th scope="row">Average Commission Income</b-th>
					<b-td>{{ customer.incomes.main.av_com_inc | moneyFormatter }}</b-td>
					<b-td v-if="isForeigIncome">{{ _gHlp.currencyFromRM(customer.incomes.main.av_com_inc,
						this.main_form.foreign_currency) | moneyFormatter }}</b-td>
				</b-tr>
				<b-tr>
					<b-th scope="row">Average Bonus Income</b-th>
					<b-td>{{ customer.incomes.main.av_bonus_inc | moneyFormatter }}</b-td>
					<b-td v-if="isForeigIncome">{{ _gHlp.currencyFromRM(customer.incomes.main.av_bonus_inc,
						this.main_form.foreign_currency) | moneyFormatter }}</b-td>
				</b-tr>

				<b-tr variant="primary" class="font-weight-bolder">
					<b-th scope="row">Gross Income</b-th>
					<b-td>{{ customer.incomes.main.gross_income | moneyFormatter }}</b-td>
					<b-td v-if="isForeigIncome">{{ _gHlp.currencyFromRM(customer.incomes.main.gross_income,
						this.main_form.foreign_currency) | moneyFormatter }}</b-td>
				</b-tr>
				<b-tr v-if="!isForeigIncome">
					<b-th scope="row">Income Tax</b-th>
					<b-td>{{ customer.incomes.main.income_tax | moneyFormatter }}</b-td>
				</b-tr>
				<b-tr v-if="customer.incomes.main.income_type_id === 1">
					<b-th scope="row">Payslip / Other Deduction</b-th>
					<b-td>{{ parseFloat(totalOtherDeduction) | moneyFormatter }}</b-td>
					<b-td v-if="isForeigIncome">{{ _gHlp.currencyFromRM(totalOtherDeduction, this.main_form.foreign_currency) |
						moneyFormatter }}</b-td>
				</b-tr>
				<b-tr v-if="!isForeigIncome">
					<b-th scope="row">EPF</b-th>
					<b-td>{{ customer.incomes.main.epf | moneyFormatter }}</b-td>
				</b-tr>
				<b-tr v-if="!isForeigIncome">
					<b-th scope="row">SOCSO</b-th>
					<b-td>{{ customer.incomes.main.sosco | moneyFormatter }}</b-td>
				</b-tr>
				<b-tr>
					<b-th scope="row">Rental Income</b-th>
					<b-td>{{ customer.incomes.main.total_rental_inc | moneyFormatter }}</b-td>
					<b-td v-if="isForeigIncome">{{ _gHlp.currencyFromRM(customer.incomes.main.total_rental_inc,
						this.main_form.foreign_currency) | moneyFormatter }}</b-td>
				</b-tr>
				<b-tr>
					<b-th scope="row">Other Income</b-th>
					<b-td>{{ customer.incomes.main.total_other_inc | moneyFormatter }}</b-td>
					<b-td v-if="isForeigIncome">{{ _gHlp.currencyFromRM(customer.incomes.main.total_other_inc,
						this.main_form.foreign_currency) | moneyFormatter }}</b-td>
				</b-tr>
				<b-tr variant="danger" class="font-weight-bolder">
					<b-th scope="row">Net Income</b-th>
					<b-td v-if="isForeigIncome">
						{{ totalNetIncomeRYM | moneyFormatter }}
					</b-td>
					<b-td v-else>{{ customer.incomes.main.net_income | moneyFormatter }}</b-td>
					<b-td v-if="isForeigIncome">{{ totalNetIncomeSGD | moneyFormatter }}</b-td>
				</b-tr>
				<b-tr v-if="customer.incomes.main.income_type_id === 3 || customer.incomes.main.income_type_id === 5">
					<b-th scope="row">Payslip / Other Deduction</b-th>
					<b-td>{{ parseFloat(totalOtherDeduction) | moneyFormatter }}</b-td>
					<b-td v-if="isForeigIncome">{{ _gHlp.currencyFromRM(totalOtherDeduction, this.main_form.foreign_currency) |
						moneyFormatter }}</b-td>
				</b-tr>
				<b-tr v-if="customer.incomes.main.income_type_id === 3 || customer.incomes.main.income_type_id === 5">
					<b-th scope="row">DSR (Net Income Ratio)</b-th>
					<b-td>{{ customer.incomes.main.net_income_ratio }}%</b-td>
					<b-td v-if="isForeigIncome">{{ _gHlp.currencyFromRM(customer.incomes.main.net_income_ratio,
						this.main_form.foreign_currency) }}%</b-td>
				</b-tr>
				<b-tr v-if="customer.incomes.main.income_type_id === 3 || customer.incomes.main.income_type_id === 5"
					variant="danger" class="font-weight-bolder">
					<b-th scope="row">Net Balance Income</b-th>
					<b-td>{{ customer.incomes.main.balance_net_income | moneyFormatter }}</b-td>
					<b-td v-if="isForeigIncome">{{ _gHlp.currencyFromRM(customer.incomes.main.balance_net_income,
						this.main_form.foreign_currency) | moneyFormatter }}</b-td>
				</b-tr>
			</b-tbody>
		</b-table-simple>
		<small class="text-break">*Bonus, Rental and Other Income are added after Net Income.</small>
	</div>
</template>
<script>
import { Table, TableColumn } from 'element-ui'
export default {
	props: ['customer', 'main_form', 'currency'],
	name: 'table-net-income-details',
	components: {
		[Table.name]: Table,
		[TableColumn.name]: TableColumn,
	},
	data() {
		return {
		}
	},
	computed: {
		isForeigIncome() {
			// return false
			const wc = _gHlp.getValue(this.main_form, 'working_country');
			return !_gHlp.isEmpty(wc) && wc != 'Malaysia';
		},
		totalOtherDeduction() {
			const oth = _gHlp.getValue(this.customer, 'incomes.main.total_other_deduction', 0);
			const ndi = _gHlp.getValue(this.customer, 'incomes.main.ndi_deduction', 0);
			const tax = _gHlp.getValue(this.customer, 'incomes.main.tax_deduction', 0);
			if (!this.isForeigIncome) {
				return oth;
			}
			return parseFloat(oth) + parseFloat(ndi) + parseFloat(tax);
		},
		// Malaysia
		totalNetIncomeRYM() {
			let payslip_other_deduction = this.getPaySlipOtherDeduction();
			const gross_income = _gHlp.getValue(this.customer, 'incomes.main.gross_income', 0);
			const bonus_income = _gHlp.getValue(this.customer, 'incomes.main.av_bonus_inc', 0);
			const rental_income = _gHlp.getValue(this.customer, 'incomes.main.total_rental_inc', 0);
			const other_income = _gHlp.getValue(this.customer, 'incomes.main.total_other_inc', 0);
			const total = parseFloat(gross_income) - payslip_other_deduction + parseFloat(rental_income) + parseFloat(other_income) + parseFloat(bonus_income);
			parseFloat(total.toFixed(2))
			return parseFloat(total.toFixed(2));
		},
		// Singapore
		totalNetIncomeSGD() {
			let payslip_other_deduction = this.getPaySlipOtherDeduction();
			payslip_other_deduction = _gHlp.currencyFromRM(
				payslip_other_deduction,
				this.main_form.foreign_currency
			);
			const gross_income = _gHlp.currencyFromRM(
				_gHlp.getValue(this.customer, 'incomes.main.gross_income', 0),
				this.main_form.foreign_currency
			);
			const bonus_income = _gHlp.currencyFromRM(
				_gHlp.getValue(this.customer, 'incomes.main.av_bonus_inc', 0),
				this.main_form.foreign_currency
			);
			const rental_income = _gHlp.currencyFromRM(
				_gHlp.getValue(this.customer, 'incomes.main.total_rental_inc', 0),
				this.main_form.foreign_currency
			);
			const other_income = _gHlp.currencyFromRM(
				_gHlp.getValue(this.customer, 'incomes.main.total_other_inc', 0),
				this.main_form.foreign_currency
			);
			const socso = _gHlp.getValue(this.customer, 'incomes.main.sosco', 0);
			const epf = _gHlp.getValue(this.customer, 'incomes.main.epf', 0);
			const incomeTax = _gHlp.getValue(this.customer, 'incomes.main.income_tax', 0);
			if (!this.isForeigIncome) {
				const net_income = _gHlp.getValue(this.customer, 'incomes.main.net_income', 0);
				const total = parseFloat(net_income) + parseFloat(socso) + parseFloat(epf) + parseFloat(incomeTax);
				return parseFloat(total.toFixed(2));
			}
			const total = parseFloat(gross_income) - payslip_other_deduction + parseFloat(rental_income) + parseFloat(other_income) + parseFloat(bonus_income);
			return parseFloat(total.toFixed(2));
		}
	},
	methods: {
		getPaySlipOtherDeduction() {
			let payslip_other_deduction = 0;
			const oth = _gHlp.getValue(this.customer, 'incomes.main.total_other_deduction', 0);
			const ndi = _gHlp.getValue(this.customer, 'incomes.main.ndi_deduction', 0);
			const tax = _gHlp.getValue(this.customer, 'incomes.main.tax_deduction', 0);
			if (!this.isForeigIncome) {
				payslip_other_deduction = oth;
			} else {
				payslip_other_deduction = parseFloat(oth) + parseFloat(ndi) + parseFloat(tax);
			}
			return payslip_other_deduction;
		},
	},
}
</script>